import { ArticleState } from "@/components/ArticlePage/redux/types";

export const articleInitialState: ArticleState = {
  articleData: null,
  error: null,
  loading: false,
  ua: undefined,
  articleSlug: null,
};
